const FormSummaryGridComponent = {
    templateUrl: '/formViewer/component/formSummary/formSummaryGrid.tpl.html',
    controller: 'formSummaryGridController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<'
    }
};

angular.module('umFormViewer')
    .component('uiFormSummaryGrid', FormSummaryGridComponent);
